import { render, staticRenderFns } from "./BuyerProductName.vue?vue&type=template&id=4f42b370&"
import script from "./BuyerProductName.vue?vue&type=script&lang=ts&"
export * from "./BuyerProductName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports